import { c as _c } from "react/compiler-runtime";
import React from "react";
interface FormSectionProps {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly titleClassName?: string;
  readonly contentClassName?: string;
}

/**
 * FormSection - A reusable component for creating form sections with titles
 *
 * This component allows customizing the styling of the section, title,
 * and content areas through className props.
 */
const FormSection: React.FC<FormSectionProps> = t0 => {
  const $ = _c(9);
  const {
    title,
    children,
    titleClassName: t1,
    contentClassName: t2
  } = t0;
  const titleClassName = t1 === undefined ? "tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-4" : t1;
  const contentClassName = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== title || $[1] !== titleClassName) {
    t3 = <div className={titleClassName}>{title}</div>;
    $[0] = title;
    $[1] = titleClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== contentClassName) {
    t4 = <div className={contentClassName}>{children}</div>;
    $[3] = children;
    $[4] = contentClassName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default FormSection;